// Frozen names the app-download interstitial shares across the boot script, the
// component, and (by reference) main.css. Change here only. The CSS cannot import
// these, so keep the literals in main.css in sync by the comment there.
export const INTERSTITIAL_COOKIE = "folio_web_pref";
export const SHOW_CLASS = "folio-show-interstitial";
export const UA_IOS_CLASS = "folio-ua-ios";
export const UA_ANDROID_CLASS = "folio-ua-android";
